import { useState } from 'react';
import { LineHelper } from '../../../../../../../helpers/line.helper';
import type { ILine } from '../../../../../../../models/line.model';

export default function CallMarker({ isAtStop, line }: { isAtStop: boolean; line: ILine }) {
  const [hasArrived, setHasArrived] = useState(isAtStop);

  // NV-9103: Remember arrival only while this keyed stop row exists, including its exit transition.
  if (isAtStop && !hasArrived) setHasArrived(true);

  return (
    <span
      className={`journey-panel__stop-marker ${hasArrived ? 'journey-panel__stop-marker--at-stop' : ''}`}
      aria-hidden="true"
      style={hasArrived ? undefined : { backgroundColor: LineHelper.getBackgroundColor(line) }}
    />
  );
}
